import { Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ValidationService } from './validation.service';

@Component({
  selector: 'control-messages',
  template: `<div *ngIf="errorMessage !== null" style="color: #A94442">{{errorMessage}}</div>`
})
export class ControlMessagesComponent {
  // errorMessage: string;
  @Input() control: FormControl;
  @Input() submitted : any;
  constructor() { }

  get errorMessage() {
    if(this.submitted === 'true'){
      // console.log(this.submitted);
      for (let propertyName in  this.control && this.control.errors) {
        if (this.control.errors.hasOwnProperty(propertyName) ) {
          return ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
        }
      }
    }
    return null;
  }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/utilities/control-messages.component.ts